import { Avatar, Button, Divider } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { PostTypeIcon } from '@/components'
import { Group, PostType, SectionType, useGetViewerQuery } from '@/generated/graphql'
import { EventPostModal } from '@/modules/post/event-post/event-post-modal.component'
import { routes } from '@/routes'

import { PostEditor } from './post-editor.component'
import s from './post-editor.module.less'
import { PostTypeMenu } from './post-type-menu'

interface PostEditorContainerProps {
  group?: Group
  sectionId?: SectionType
}

export const PostEditorContainer: React.FC<PostEditorContainerProps> = ({ group, sectionId }) => {
  const [t] = useTranslation()
  const { data: me } = useGetViewerQuery()
  const [visible, setVisible] = React.useState(false)
  const [postType, setPostType] = React.useState<PostType>(PostType.General)

  const groupId = group ? group.groupId : sectionId ? 1 : undefined
  const commonProps = { groupId, sectionId }

  const postEditor = (
    <PostEditor {...commonProps} visible={visible} onClose={() => setVisible(false)} postType={postType} />
  )

  return (
    <div className={s.postCreator}>
      <div className={s.postCreate}>
        <div>
          <Link to={routes.me.home()}>
            <Avatar size='large' src={me!.viewer.avatarUrl} />
          </Link>
        </div>
        <div
          className={s.creator}
          onClick={() => {
            setVisible(true)
            setPostType(PostType.General)
          }}
        >
          {me!.viewer.name + '，' + t('post.editor.placeholder')}
        </div>
        {postEditor}
        <div className={s.typeMenu}>
          <PostTypeMenu {...commonProps} />
        </div>
      </div>
      <Divider />
      <div className={s.fastCreate}>
        <Button
          onClick={() => {
            setVisible(true)
            setPostType(PostType.Forum)
          }}
        >
          <PostTypeIcon type={PostType.Forum} withText={true} style={{ color: '#FEAF4F' }} />
        </Button>
        <EventPostModal {...commonProps}>
          <Button>
            <PostTypeIcon type={PostType.Event} withText={true} style={{ color: '#E00034' }} />
          </Button>
        </EventPostModal>
      </div>
    </div>
  )
}
